import React, { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState, indicatorState, companyFileNameState } from "../../stores/atoms";
import { auth } from "../../actions/firebase";
import { awsInstance } from "../../actions/api";
import ModalForCallNumber from "../modal/ModalForCallNumber";
import {
  setPhoneTemplate,
  setCorporateNumberTemplate,
  S3_BASE_URL
} from "../../actions/utiles";
import ModalForCompanyFile from "../modal/ModalForCompanyFile";

function MyInfo() {
  const [, setIndicator] = useRecoilState(indicatorState);
  const user = useRecoilValue(userState);
  const [companyFileName, setCompanyFileName] = useRecoilState(companyFileNameState);
  const [modalShow, setModalShow] = useState(false);
  const [fileModalShow, setFileModalShow] = useState(false);
  const [myInfo, setMyInfo] = useState(null);
  const [callNumber, setCallNumber] = useState("");
  const fileButtonRef = useRef();

  useEffect(() => {
    setIndicator("홈 > 내 정보");
    setCallNumber(user.call_number);

    const getMyinfo = async () => {
      try {
        const { data } = await awsInstance.get("/business/my-info", {
          params: {
          id: user.business_user_id
          },
        });
        if (data.code === "SUCCESS") {
          const info = data.data;
          setMyInfo(info);
          setCompanyFileName(info.license_file_name);
        } else {
          alert(data.message);
        }
      } catch (e) {
        alert(e);
      }
    };
    getMyinfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callNumber, user.call_number, companyFileName]);

  const onPasswordChangeClick = async (event) => {
    event.preventDefault();
    try {
      await auth.sendPasswordResetEmail(user.email);
      alert("가입하신 이메일로 비밀번호 변경 링크를 전송하였습니다.");
    } catch (e) {
      if (e.code === "auth/user-not-found") {
        alert("이메일이 올바르지 않습니다.");
      } else {
        alert("이메일 전송이 실패하였습니다.");
      }
    }
  };

  const getAuthorized = (authorized) => {
    const adminAuth = "관리책임자"
    switch (authorized) {
      case 2:
        return "운영담당자1";
  
      case 3:
        return "운영담당자2";
  
      default:
        return adminAuth;
    }
  };

  const getText = () => {
    let text = "";
    if (!myInfo) {
      return;
    }
    if (myInfo && myInfo.use_card === 1 && myInfo.use_tax_bill === 1) {
      text = "법인카드 / 세금계산서";
    } else if (myInfo.use_tax_bill === 1 && myInfo.use_card === 0) {
      text = "세금계산서";
    } else if (myInfo.use_card === 1 && myInfo.use_tax_bill === 0) {
      text = "법인카드";
    }
    return text;
  };

  return (
    <>
      <div className="my_info">
        <h5>내 정보</h5>
        <table className="table">
          <tbody>
            <tr>
              <th className="width-15" rowSpan="4">
                <p className="txt-dark-gray m-0 font-bolder">사업자정보</p>
              </th>
              <td className="width-20">
                <p className="font-bold txt-gray mb-0">사업자 번호</p>
              </td>
              <td className="txt-left width-auto">
                <span className="txt-dark-gray ">
                  {myInfo &&
                    setCorporateNumberTemplate(
                      myInfo.corporate_registration_number
                    )}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <p className="font-bold txt-gray mb-0">사업자 등록증</p>
              </td>
              <td className="txt-left">
                <span className="txt-dark-gray mr-3">{(myInfo && myInfo.license_file_name) ? '' : '미등록'}
                <a className="txt-dark-gray txt-decoration-none" target="_blank" rel="noreferrer" href={`${S3_BASE_URL}${myInfo && myInfo.license_file_path}`}>{companyFileName}</a>
                </span>
                <button
                  className="btn-white"
                  ref={fileButtonRef} 
                  onClick={() => setFileModalShow(true)}
                >
                  변경
                </button>
              </td>
            </tr>
            <tr>
              <td>
                <p className="font-bold txt-gray mb-0">사업자명</p>
              </td>
              <td className="txt-left">
                <span className="txt-dark-gray ">
                  {myInfo && myInfo.company_name}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <p className=" font-bold txt-gray mb-0">호출번호</p>
              </td>
              <td className="txt-left">
                <span className="txt-dark-gray mr-3">{callNumber}</span>
                <button
                  className="btn-white"
                  onClick={() => setModalShow(true)}
                >
                  변경
                </button>
              </td>
            </tr>
            <tr>
              <th rowSpan="6">
                <p className="txt-dark-gray m-0 font-bolder">관리자정보</p>
              </th>
            </tr>
            <tr>
              <td>
                <p className=" font-bold txt-gray mb-0">이메일</p>
              </td>
              <td className="txt-left">
                <span className="txt-dark-gray ">{user.email}</span>
              </td>
            </tr>
            <tr>
              <td>
                <p className=" font-bold txt-gray mb-0">비밀번호</p>
              </td>
              <td className="txt-left">
                <span className="txt-dark-gray mr-3">********</span>
                <button className="btn-white" onClick={onPasswordChangeClick}>
                  변경
                </button>
              </td>
            </tr>
            <tr>
              <td>
                <p className="font-bold txt-gray mb-0">이름</p>
              </td>
              <td className="txt-left">
                <span className="txt-dark-gray">{user.name}</span>
              </td>
            </tr>
            <tr>
              <td>
                <p className=" font-bold txt-gray mb-0">전화번호</p>
              </td>
              <td className="txt-left">
                <span className="txt-dark-gray ">
                  {setPhoneTemplate(user.phone_number)}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <p className=" font-bold txt-gray mb-0">권한</p>
              </td>
              <td className="txt-left">
                <span className="txt-dark-gray ">
                  {getAuthorized(user.authorized)}
                  
                </span>
              </td>
            </tr>
            <tr>
              <th rowSpan="5">
                <p className="txt-dark-gray m-0 font-bolder">결제정보</p>
              </th>
              <td>
                <p className=" font-bold txt-gray mb-0">결제수단</p>
              </td>
              <td className="txt-left">
                <span className="txt-dark-gray ">{getText()}</span>
              </td>
            </tr>
            <tr>
              <td>
                <p className=" font-bold txt-gray mb-0">연계고용제도 활용</p>
              </td>
              <td className="txt-left">
                <span className="txt-dark-gray ">
                  {myInfo && myInfo.use_system === 1 ? "사용 " : "사용 안 함"}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ModalForCallNumber show={modalShow} onHide={() => setModalShow(false)} />
      <ModalForCompanyFile show={fileModalShow} onHide={() => setFileModalShow(false)} />
    </>
  );
}

export default MyInfo;
